import { createSlice } from '@reduxjs/toolkit';
import { ApiBadgeType, BadgeType } from 'src/features/Gamification/types';

export type BadgesStateType = {
  items: Array<ApiBadgeType>;
  status: string;
  meta: {
    page: number;
    total: number;
    next: null | string;
  };
};

const initialState: BadgesStateType = {
  items: [],
  status: 'idle',
  meta: {
    page: 1,
    total: 0,
    next: null,
  },
};

const badgesSlice = createSlice({
  name: 'badges',
  initialState,
  reducers: {
    deleteBadge: (state, action) => {
      state.items = state.items.filter(
        ({ id }: BadgeType) => id !== action.payload.id
      );
      state.meta.total -= 1;
    },
    addBadge: (state, action) => {
      state.items = [action.payload.item, ...state.items];
      state.meta.total = +1;
    },
    updateBadge: (state, action) => {
      state.items.splice(
        state.items.findIndex(item => item.id === action.payload.item.id),
        1,
        action.payload.item
      );
    },
    fetchBadges: (state, action) => {
      if (!action.payload.items) return;

      state.items = action.payload.items;
      state.meta.total = action.payload.total;
    },
  },
});

export default badgesSlice.reducer;

export const {
  fetchBadges: fetchBadgesAction,
  addBadge: addBadgeAction,
  updateBadge: updateBadgeAction,
  deleteBadge: deleteBadgeAction,
} = badgesSlice.actions;
